export default __webpack_public_path__ + "static/media/PPI-pools-001.0f4e404a.jpg";